export class RecoveryRequestEvent {
	constructor(
		public email: string,
	) {
	}
}
